import { sizes as cmdSizes } from 'citymd/constants/device';
import { useCallback, useEffect, useState } from 'react';

const useIsMobile = (): boolean => {
    const [isMobileView, setIsMobileView] = useState((document.body?.clientWidth ?? 0) <= cmdSizes.mobile);

    const handleWindowResize = useCallback(() => {
        setIsMobileView((document.body?.offsetWidth ?? 0) <= cmdSizes.mobile);
    }, []);

    useEffect(() => {
        const client = new ResizeObserver(handleWindowResize);
        client.observe(document.body);
        return () => client.disconnect();
    }, [handleWindowResize]);

    return isMobileView;
};

export { useIsMobile };
